import Link from "next/link";
import styles from "./css/AboutHeader.module.css";
import { ButtonTheme, ButtonWithText, FontClass } from "ui";
import { useIsLoggedIn } from "@web/hooks/auth/useIsLoggedIn";
import { isFromNative } from "@web/utils/env/isFromNative";

export function AboutHeader() {
  const isLoggedIn = useIsLoggedIn();
  const fromNative = isFromNative();
  return (
    <div className={styles.container}>
      <Link href="/">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className={styles.sokiLogo}
          src="/images/harken-logo-purple.svg"
          alt="Logo"
        />
      </Link>
      <ButtonWithText
        buttonTheme={ButtonTheme.Highlight}
        fontClass={FontClass.Body1Medium}
        href={
          fromNative
            ? isLoggedIn
              ? "/decks"
              : "/native/login"
            : isLoggedIn
            ? "/decks"
            : "/login"
        }
        type="link_internal"
      >
        Go to App
      </ButtonWithText>
    </div>
  );
}
